/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class CooperationMember extends Mb {
    constructor() {
        super();
        this.baseUrl += '/cooperationMember';
    }

    data({
        fullName,
        idCardNo,
        tel,
        isWriteOff,
        discountCodeType,
        discountId,
        codeStatus,
        currentPage,
        pageSize,
    } = {}) {
        return super.get('/data', {
            fullName,
            idCardNo,
            tel,
            isWriteOff,
            discountCodeType,
            discountId,
            codeStatus,
            currentPage,
            pageSize,
        });
    }

    relatedStatementVoucher({ ids, enterpriseStatementVoucherId }) {
        return super.post('/relatedStatementVoucher', { ids, enterpriseStatementVoucherId });
    }

    relatedStatementVoucherItem({ id, voucherList }) {
        return super.post('/relatedStatementVoucherItem', { id, voucherList });
    }
}

export default new CooperationMember();
export { CooperationMember };
